"use client";
import ResumeBuilderComponent from "components/ResumeBuilderComponent";
export default function Create() {
  return <ResumeBuilderComponent />;

}
